import type { Features } from "@app/types/experiments";
import type { NapiV2CartCharges } from "@app/types/napi-v2-charges-types";

import type { LocalizedPriceParams } from "./v4-migration-helper/normalize-localized-price";
import type { SupportedLocale } from "@config/locales";

import { IncludedFees, shouldIncludeFees } from "../price";

interface FeesAndTaxesOptions {
  include_fees?: IncludedFees;
  include_taxes?: boolean;
}

export const getLocalizedPrice = (
  prices: LocalizedPriceParams,
  fees_and_taxes_options: FeesAndTaxesOptions = {}
): number => {
  const { include_fees, include_taxes } = fees_and_taxes_options;

  const { base, supplier_fees, busbud_fees, taxes } = prices;
  let display_price = base;

  if (include_fees === IncludedFees.ALL) {
    display_price += busbud_fees + supplier_fees;
  } else if (include_fees === IncludedFees.SUPPLIER_ONLY) {
    display_price += supplier_fees;
  }

  if (include_taxes) {
    display_price += taxes;
  }

  return display_price;
};

export const getCartChargesLocalizedPrice = (
  charges: NapiV2CartCharges,
  origin_country: string | undefined,
  user_country: string,
  user_region: string | undefined,
  locale: SupportedLocale,
  features: Partial<Features>
): number => {
  const { fees, subtotal } = charges;
  let display_price = subtotal;

  // TODO: Add sources
  if (
    shouldIncludeFees({
      origin_country,
      user_country,
      user_region,
      locale,
      features
    })
  ) {
    display_price += fees.total;
  }

  return display_price;
};
